export interface MmaoOffersSearchInput {
  offerId?: string;
  createdBy?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
}

export function getMmaoOffersSearchInputFromSearchParams(searchParams: URLSearchParams): MmaoOffersSearchInput {
  const input: MmaoOffersSearchInput = {};

  const offerId = searchParams.get('offerId');
  if (offerId) {
    input.offerId = offerId;
  }

  const createdBy = searchParams.get('createdBy');
  if (createdBy) {
    input.createdBy = createdBy;
  }

  const updatedAtFrom = searchParams.get('updatedAtFrom');
  if (updatedAtFrom) {
    input.updatedAtFrom = updatedAtFrom;
  }

  const updatedAtTo = searchParams.get('updatedAtTo');
  if (updatedAtTo) {
    input.updatedAtTo = updatedAtTo;
  }

  return input;
}
